import { render, staticRenderFns } from "./Foerderung.vue?vue&type=template&id=332b17e2&scoped=true&"
import script from "./Foerderung.vue?vue&type=script&lang=js&"
export * from "./Foerderung.vue?vue&type=script&lang=js&"
import style0 from "./Foerderung.vue?vue&type=style&index=0&id=332b17e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "332b17e2",
  null
  
)

export default component.exports